<template>
  <div class="min-h-screen bg-[#0F0F0F] text-white py-10 px-4 md:px-10">
    <div
      class="max-w-4xl mx-auto bg-[#1F1F1F] p-8 rounded-2xl shadow-xl border border-gray-700"
    >
      <h1 class="text-3xl md:text-4xl font-bold text-center mb-8">
        {{ $t("cookie.title") }}
      </h1>

      <div class="space-y-6 text-gray-300 text-sm leading-relaxed">
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t("cookie.section1.title") }}
          </h2>
          <p class="text-sm text-gray-400 leading-relaxed">
            {{ $t("cookie.section1.text1") }}
            <b class="text-white">{{ $t("cookie.section1.brand") }}</b>
            {{ $t("cookie.section1.text2") }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t("cookie.section2.title") }}
          </h2>
          <p class="text-sm text-gray-400 leading-relaxed">
            {{ $t("cookie.section2.text1") }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t("cookie.section3.title") }}
          </h2>
          <ul
            class="list-disc list-inside space-y-1 text-sm text-gray-400 leading-relaxed"
          >
            <li>
              <b class="text-white">{{
                $t("cookie.section3.items.sessionbrand")
              }}</b>
              {{ $t("cookie.section3.items.sessiontext") }}
            </li>
            <li>
              <b class="text-white">{{
                $t("cookie.section3.items.persistentbrand")
              }}</b>
              {{ $t("cookie.section3.list[0]") }}
            </li>
            <li>
              <b class="text-white">{{
                $t("cookie.section3.items.analyticsbrand")
              }}</b>
              {{ $t("cookie.section3.items.analyticstext") }}
            </li>
            <li>
              <b class="text-white">{{
                $t("cookie.section3.items.functionalbrand")
              }}</b>
              {{ $t("cookie.section3.items.functionaltext") }}
            </li>
          </ul>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t("cookie.section4.title") }}
          </h2>
          <p>
            <b class="text-white">{{ $t("cookie.section4.brand") }}</b>
            {{ $t("cookie.section4.text1") }}
          </p>
          <ul
            class="list-disc list-inside space-y-1 text-sm text-gray-400 leading-relaxed"
          >
            <li>
              {{ $t("cookie.section4.list[0]") }}
            </li>
            <li>
              {{ $t("cookie.section4.list[1]") }}
            </li>
            <li>
              {{ $t("cookie.section4.list[2]") }}
            </li>
            <li>
              {{ $t("cookie.section4.list[3]") }}
            </li>
          </ul>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t("cookie.section5.title") }}
          </h2>
          <p>
            {{ $t("cookie.section5.desc") }}
          </p>
        </section>
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t("cookie.section6.title") }}
          </h2>
          <p>
            {{ $t("cookie.section6.desc") }}
          </p>
        </section>
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t("cookie.section7.title") }}
          </h2>
          <p>
            {{ $t("cookie.section7.desc") }}
          </p>
        </section>
      </div>

      <div class="mt-10 text-center text-gray-500 text-xs">
        © {{ new Date().getFullYear() }} {{ $t("cookie.copyright") }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: "default" });
</script>
